import { decorate, observable } from "mobx";
import ValidationModel from "../../../../../models/ValidationModel/ValidationModel";
import ValidationRulePattern from "../../../../../models/ValidationModel/ValidationRulePattern";
import { I18n } from 'aws-amplify';

class WebsiteContact extends ValidationModel {
    value = ''
    type = 'personal'

    constructor(data) {
        super();
        if (data) {
            this.value = data.value;
            this.type = data.type;
        }
    }

    getRules() {
        return {
            value: {
                format: {
                    pattern: ValidationRulePattern.WEB_ADDRESS_OR_EMPTY,
                    message: I18n.get("_action_wrong_link")
                }
            },
        };
    }
}

decorate(WebsiteContact, {
    value: observable,
    type: observable,
})

export default WebsiteContact
